import React, {FC, useCallback, useEffect, memo} from 'react';
import {Link, generatePath} from "react-router-dom";
import {useSelector, useDispatch} from 'react-redux';
import routes from '../../../config/routes';

// Import Styles
import styled from 'styled-components';
import colors from '../../../config/colors';
import H3 from '../../../components/Headings/H3';
import  {LoadOverlayFadingCircle} from '../../../components/Animations';

import {Job} from '../../../models/jobs';

// Import Messages and Date
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
// Import Actions
import {getFeaturedJobs} from '../../App/actions';

// Import Selectors
import {featuredCurrentPage, featuredPageCount, makeSelectFeaturedJobs, makeSelectFeaturedJobsLoading} from '../../App/selectors';

import Card from '../../../components/Cards/jobs';
import RowSm from '../../../components/Layout/RowSm';
import Col3 from '../../../components/Layout/Grid/Col3';
import NoResultsStyle from '../../../components/NoResults/NoResultsStyle';
import generalMessages from '../../generalMessages';
import P from '../../../components/Paragraph';
import MainWrapper from '../../../components/PageSections/MainWrapper';
import ReactPaginate from 'react-paginate';
import PaginateWrapper from '../../../components/Pagination';
import {Heading} from '../../../components/PageSections/Heading';
import { AnimationOnScroll } from 'react-animation-on-scroll';

const FeaturedJobs: FC = () => {

  const dispatch = useDispatch();

  const featuredJobs = useSelector(makeSelectFeaturedJobs);
  const loading =  useSelector(makeSelectFeaturedJobsLoading);

  const pageCount = useSelector(featuredPageCount);
  const currentPage = useSelector(featuredCurrentPage);

  useEffect(()=>{
    let page = 1;
    dispatch(getFeaturedJobs(page));

  }, [dispatch]);

  const handlePageClick = useCallback((data: any) => {
    let page = data.selected >= 0 ? data.selected + 1 : 0;
    dispatch(getFeaturedJobs(page));
  }, [dispatch]);

  return (
      <MainWrapper theme="gray_extra_light">
        <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true} duration={1.8}>
          <Heading>
            <H3><FormattedMessage {...messages.ProminentAdsTitle} /></H3>
            <Link to={generatePath(routes.Jobs)}>Pogledaj sve</Link>
          </Heading>
          <RowJobsSm>
            {loading ? <LoadOverlayFadingCircle /> :
              featuredJobs && featuredJobs.length > 0 ?
                featuredJobs.map((featuredJobs: Job, j: number)=> {
                  return (
                    <Col3Jobs key={j}>
                      <Card job={featuredJobs} />
                    </Col3Jobs>
                  )
                })
              : <NoResultsStyle><P><FormattedMessage {...generalMessages.NoResults}/></P></NoResultsStyle>
            }
          </RowJobsSm>
          {pageCount > 1 &&
            <PaginateWrapper>
              <ReactPaginate
                previousLabel={<svg><use xlinkHref={`#arrow-left`} /></svg>}
                nextLabel={<svg><use xlinkHref={`#arrow-right`} /></svg>}
                pageCount={pageCount}
                forcePage={currentPage - 1}
                marginPagesDisplayed={1}
                pageRangeDisplayed={2}
                onPageChange={handlePageClick}
                containerClassName={'pagination-white'}
                disabledClassName={"disabled"}
                activeClassName={'active'}
              />
            </PaginateWrapper>
            }
            <EmptyCircle></EmptyCircle>
          </AnimationOnScroll>
      </MainWrapper>
  )
}

const Col3Jobs = styled(Col3)`
  display: flex;
  z-index: 1;

  @media (max-width: 1200px) {
    flex: 33.3333%;
    max-width: 33.3333%;
  }

  @media (max-width: 992px) {
    flex: 50%;
    max-width: 50%;
  }

  @media (max-width: 576px) {
    flex: 100%;
    max-width: 100%;
  }
`;

const RowJobsSm = styled(RowSm)`
  min-height: 440px;
  position: relative;
  z-index: 1;
`;

const EmptyCircle = styled.div`
  position: absolute;
  box-sizing: border-box;
  top: 70%;
  left: -12%;
  opacity: 0.2;
  border: 50px solid ${colors.PURPLE_COLOR};
  border-radius: 50%;
  width: 375px;
  height: 375px;
`;

export default memo(FeaturedJobs);
